import { Config } from "src/config";
export const environment = {
  production: false,
  apiUrl: Config['PROD_API_URL'] || '',
  SOCKET_ENDPOINT: Config['PROD_SOCKETENDPOINT'] || '',
  fbAppId: Config['PROD_FBAPPID'] || '',
  googleClientId: Config['PROD_GOOGLECLIENTID'] || '',
  sslPinning: Config['PROD_SSLPINNING'] || '',
  paymentGatewayUrl: Config['PROD_PAYMENTGATEWAYURL'] || '',
  paymentGatewayUrl_1: Config['PROD_PAYMENTGATEWAYURL_1'] || '',
  encryptPaymentPublicKey: Config['PROD_ENCRYPT_PAYMENT_PUBLIC_KEY'] || '',
  redirectUrl: Config['PROD_REDIRECTURL'] || ''
};